// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3kVPm","title":"Header_title__XWx7a","left":"Header_left__29-II","clinicName":"Header_clinicName__1pXlD"};